import styled from 'styled-components';

import { Text } from '@gympass/yoga';

export const ResumeContainer = styled.div``;

export const ResumeTitle = styled(Text.H5)`
  margin: ${({ theme }) => theme.yoga.spacing.medium}px;
  margin-left: 0;
  color: ${({ theme }) => theme.yoga.colors.black};
  font-weight: ${({ theme }) => theme.yoga.fontWeights.bolder};
  font-size: ${({ theme }) => theme.yoga.spacing.large}px;
`;
